import { batchSubjectConfigurationForResultSheetQuery, studentsForResultSheetQuery } from '@app-types/graphql-types';
import { StudentResult, StudentResultSheet } from '@modules/resultSheet';

interface GetStudentResultSheetDataArgs {
  selectedSubject: batchSubjectConfigurationForResultSheetQuery['batch_subject_configuration'][0];
  studentsWithAttendance: studentsForResultSheetQuery['studentsWithAttendance'];
}

export const getStudentResultSheetData = ({
  selectedSubject,
  studentsWithAttendance,
}: GetStudentResultSheetDataArgs): StudentResultSheet[] => {
  const studentResults: StudentResult[] = [];

  if (selectedSubject?.assessments) {
    studentResults.push(
      ...selectedSubject.assessments.map((assessment) => ({
        assessmentId: assessment.id,
        assessmentTitle: `${assessment.title}`,
        allocatedMarks: assessment.totalMarks,
      })),
    );
  }

  return studentsWithAttendance.map((student) => ({
    id: student.id,
    attendance: student.attendance,
    name: `${student.firstName} ${student.lastName}`,
    regNumber: student.regNumber,
    remarks: '',
    customMarks: undefined,
    studentResults,
  }));
};
